import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    const lenis = window.__lenis;
    if (hash) {
      const scrollToTarget = () => {
        const el = document.querySelector(hash);
        if (!el) return false;
        if (lenis) lenis.scrollTo(el, { offset: -100, duration: 1.1 });
        else el.scrollIntoView({ behavior: "smooth", block: "start" });
        return true;
      };
      // Retry briefly in case the target mounts on the next frames.
      let tries = 0;
      const id = setInterval(() => {
        if (scrollToTarget() || ++tries > 12) clearInterval(id);
      }, 60);
      return () => clearInterval(id);
    }
    if (lenis) lenis.scrollTo(0, { immediate: true, force: true });
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}
